import { Textarea } from "@jewlr/storybook/form"
import PropTypes from "prop-types"
import React from "react"
import { Controller } from "react-hook-form"
import styled from "styled-components"

const GiftMessage = styled(Textarea)`
  height: 85px;
  margin-bottom: 0;
  ${({ theme }) => theme.mediaQueries.tablet`
    flex-basis: 100%;
  `};
`

const GiftCardTextArea = ({ control, name, placeholder, type }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <GiftMessage error={error} placeholder={placeholder} {...field} />
      )}
      type={type}
    />
  )
}

GiftCardTextArea.propTypes = {
  control: PropTypes.object,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
}

export default GiftCardTextArea
